import { render } from "./SocialBar.vue?vue&type=template&id=56eda035&scoped=true"
import script from "./SocialBar.vue?vue&type=script&lang=js"
export * from "./SocialBar.vue?vue&type=script&lang=js"

import "./SocialBar.css?vue&type=style&index=0&id=56eda035&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56eda035"]])

export default __exports__